import { useTran } from "@/hooks";

const ESGPerformanceTable = ({
  pillar,
  disclosures,
  color,
  className = "",
  getDisclosureValue,
  isDisclosureCompleted,
}) => {
  const { t } = useTran();
  const pillarLabel = t(pillar);
  const pillarLabelLower = pillarLabel.toLowerCase();

  return (
    <div className={`esg-avoid-break bg-white p-12 ${className}`}>
      <h2
        className="esg-section-heading text-3xl font-bold text-slate-900 mb-6"
        style={{ borderTopColor: color }}
      >
        {t("{{pillar}} Performance", { pillar: pillarLabel })}
      </h2>

      {disclosures && disclosures.length > 0 ? (
        <table className="esg-performance-table w-full">
          <thead>
            <tr>
              <th className="w-[15%] text-left">{t("Code")}</th>
              <th className="w-[50%] text-left">{t("Indicator")}</th>
              <th className="w-[20%] text-right">{t("Value")}</th>
              <th className="w-[15%] text-left">{t("Unit")}</th>
            </tr>
          </thead>
          <tbody>
            {disclosures.map((disclosure) => {
              const { value, unit } = getDisclosureValue(disclosure.code);
              const completed = isDisclosureCompleted(disclosure.code);
              return (
                <tr key={disclosure.code}>
                  <td className="font-semibold text-slate-900">
                    {disclosure.displayCode || disclosure.code}
                  </td>
                  <td className="text-slate-700">
                    {disclosure.title}
                    {completed ? (
                      <span className="ml-2 inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-800">
                        ✓
                      </span>
                    ) : null}
                  </td>
                  <td className="text-right font-semibold text-slate-900">
                    {value}
                  </td>
                  <td className="text-slate-600">{unit}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-6 text-center">
          <p className="text-sm text-slate-500">
            {t("No {{pillar}} disclosures available in this report.", {
              pillar: pillarLabelLower,
            })}
          </p>
        </div>
      )}

      {disclosures && disclosures.length > 0 ? (
        <div className="mt-4 flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50 p-4">
          <p className="text-sm text-slate-600">
            <strong>
              {t("Total {{pillar}} Disclosures:", { pillar: pillarLabel })}
            </strong>{" "}
            {disclosures.length}
          </p>
          <p className="text-sm text-slate-600">
            <strong>{t("Completed")}:</strong>{" "}
            {disclosures.filter((d) => isDisclosureCompleted(d.code)).length} of{" "}
            {disclosures.length}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default ESGPerformanceTable;
